module.exports = __webpack_public_path__ + "img/xiazai02.8a08d64f.png";